import AppFooter from "./AppFooter";
import { AppFooterInterface } from "./IAppFooter";

export type { AppFooterInterface };
export default AppFooter;
